import { taskCallBack, deleteInstanceById } from "@/api/myInitiative";
import { ElMessage, ElMessageBox } from "element-plus";
import { ref } from "vue";
export default function useMyInitiativeAdjust(getList) {
  const adjustRef = ref(null);
  // 点击撤回
  const handleRevocation = (row) => {
    ElMessageBox.confirm("确定撤回该流程?", "警告", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        taskCallBack(row.id).then((res) => {
          if (res.code == "2000") {
            ElMessage.success("操作成功");
            getList();
          }
        });
      })
      .catch(() => {});
  };

  // 点击删除
  const handleDelete = (row) => {
    ElMessageBox.confirm("确定删除该流程?", "删除", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "error",
    })
      .then(() => {
        deleteInstanceById(row.id).then((res) => {
          if (res.code == "2000") {
            ElMessage.success("操作成功");
            getList();
          }
        });
      })
      .catch(() => {});
  };

  // 点击详情
  const handleDetail = (row) => {
    adjustRef.value?.handleDialogOpen(row.id);
  };
  return {
    adjustRef,
    handleRevocation,
    handleDelete,
    handleDetail,
  };
}
